import { __extends } from "tslib";
import { ASObject, Errors, checkNullParameter } from '@awayfl/avm2';
import { release, notImplemented } from '@awayfl/swf-loader';
import { PerspectiveProjection } from './PerspectiveProjection';
import { Transform as AwayTransform } from '@awayjs/core';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: Transform
var Transform = /** @class */ (function (_super) {
    __extends(Transform, _super);
    function Transform(displayObjectAdaptee) {
        var _this = _super.call(this) || this;
        if (!displayObjectAdaptee)
            _this.sec.throwError('ArgumentError', Errors.NullPointerError, 'displayObject');
        _this._adaptee = (displayObjectAdaptee instanceof AwayTransform) ? displayObjectAdaptee : new AwayTransform();
        return _this;
    }
    Object.defineProperty(Transform.prototype, "adaptee", {
        get: function () {
            return this._adaptee;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Transform.prototype, "matrix", {
        get: function () {
            return new this.sec.flash.geom.Matrix(this._adaptee.matrix);
        },
        set: function (value) {
            this._adaptee.matrix = value.adaptee;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Transform.prototype, "colorTransform", {
        get: function () {
            return new this.sec.flash.geom.ColorTransform(this._adaptee.colorTransform);
        },
        set: function (value) {
            this._adaptee.colorTransform = value.adaptee;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Transform.prototype, "concatenatedMatrix", {
        get: function () {
            return new this.sec.flash.geom.Matrix(this._adaptee.matrix);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Transform.prototype, "concatenatedColorTransform", {
        get: function () {
            release || notImplemented('public flash.geom.Transform::get concatenatedColorTransform');
            return new this.sec.flash.geom.ColorTransform(this._adaptee.colorTransform);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Transform.prototype, "pixelBounds", {
        get: function () {
            // Only somewhat implemented because this is largely untested.
            release || notImplemented('public flash.geom.Transform::get pixelBounds');
            return new this.sec.flash.geom.Rectangle(this._adaptee.pixelBounds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Transform.prototype, "matrix3D", {
        get: function () {
            return new this.sec.flash.geom.Matrix3D(this._adaptee.matrix3D);
        },
        set: function (m) {
            release || notImplemented('public flash.geom.Transform::set matrix3D');
        },
        enumerable: false,
        configurable: true
    });
    Transform.prototype.getRelativeMatrix3D = function (relativeTo) {
        checkNullParameter(relativeTo, 'relativeTo', this.sec);
        release || notImplemented('public flash.geom.Transform::getRelativeMatrix3D');
        // TODO: actually calculate the relative matrix.
        return new this.sec.flash.geom.Matrix3D(this._adaptee.matrix3D);
    };
    Object.defineProperty(Transform.prototype, "perspectiveProjection", {
        get: function () {
            release || notImplemented('public flash.geom.Transform::get perspectiveProjection');
            return new PerspectiveProjection();
        },
        set: function (projection) {
            release || notImplemented('public flash.geom.Transform::set perspectiveProjection');
        },
        enumerable: false,
        configurable: true
    });
    Transform.classInitializer = null;
    return Transform;
}(ASObject));
export { Transform };
